// Import generateSync directly from @otplib/totp because Metro's package-exports
// resolution in React Native 0.79 doesn't honor the otplib root's `exports` map
// for the ESM/CJS interop (results in `_otplib.generateSync is undefined`).
// The subpackage has a plain `main: ./dist/index.cjs` that Metro resolves correctly.
import { generateSync } from '@otplib/totp';
import { NobleCryptoPlugin } from '@otplib/plugin-crypto-noble';
import { ScureBase32Plugin } from '@otplib/plugin-base32-scure';

const cryptoPlugin = new NobleCryptoPlugin();
const base32Plugin = new ScureBase32Plugin();

/**
 * Generate the current TOTP code for the given base32 secret.
 *
 * Algorithm: SHA1, 6 digits — matches the backend's otplib configuration.
 * The `period` (rotation interval in seconds) is required and must match
 * the value the BE returned in the check-in session response.
 *
 * Pure JS (synchronous) — usable from both mobile (React Native) and web.
 * Throws if the secret is not valid base32 or if period is missing.
 */
export function generateTotpCode(secret, { period }) {
  if (!period) {
    throw new Error('generateTotpCode: period is required');
  }
  return generateSync({
    secret,
    algorithm: 'sha1',
    digits: 6,
    period,
    crypto: cryptoPlugin,
    base32: base32Plugin,
  });
}
